module.exports = "import React, { Component } from 'react'\nimport shallowCompare from 'react-addons-shallow-compare'\n\nclass MyComponent extends Component {\n  shouldComponentUpdate(nextProps, nextState) {\n    return shallowCompare(this, nextProps, nextState)\n  }\n\n  render () {\n    // Your render logic here\n  }\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./examples/shallow-compare.js
 ** module id = 293
 ** module chunks = 0
 **/